<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Make Payment Page</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Make Payment</a></li>
              <li class="breadcrumb-item active">Blank Page</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="overlay text-center" v-if="is_loading">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
        <!--            Make Payment button cube here-->
        <form @submit.prevent="makePayment()" method="POST" class="response-alert" novalidate>
          <div class="form-group required col-md-6">
            <label for="receiver_id" class="control-label">Merchant Username</label>
            <input autocomplete="off" type="text" id="receiver_id" name="receiver_id" v-model="params.receiver_id"
                   v-validate="'required'" :class="{'has-error' : errors.has('receiver_id')}"
                   class="form-control" placeholder="Merchant Username">
            <div class="help text-danger" v-show="errors.has('receiver_id')">
              {{ errors.first('receiver_id') }}
            </div>
          </div>
          <div class="form-group required col-md-6">
            <label for="trx_amount" class="control-label">Transaction Amount</label>
            <input autocomplete="off" type="number" id="trx_amount" name="trx_amount" v-model="params.trx_amount"
                   v-validate="'required'" :class="{'has-error' : errors.has('trx_amount')}"
                   class="form-control" placeholder="Transaction Amount">
            <div class="help text-danger" v-show="errors.has('trx_amount')">
              {{ errors.first('trx_amount') }}
            </div>
          </div>
          <div class="form-group col-md-6">
            <label for="trx_note" class="control-label">Transaction Note</label>
            <input autocomplete="off" type="text" id="trx_note" name="trx_note" v-model="params.trx_note"
                   :class="{'has-error' : errors.has('trx_note')}"
                   class="form-control" placeholder="Transaction Note (Optional)">
            <div class="help text-danger" v-show="errors.has('trx_note')">
              {{ errors.first('trx_note') }}
            </div>
          </div>
          <div class="form-group required col-md-6">
            <label for="password" class="control-label">Your Password</label>
            <input type="password" name="password" v-model.trim="params.password" class="form-control"
                   placeholder="Password" v-validate="'required'" :class="{ 'has-error': errors.has('password') }"/>
            <div class="help text-danger" v-show="errors.has('password')">
              {{ errors.first("password") }}
            </div>
          </div>
          <div class="col-12 col-md-6 required" v-if="type === 'pin'">
            <label for="pin" class="control-label">Your Pin Number</label>
            <div class="form-group mb-3">
              <input type="number" name="pin" v-model.trim="params.pin" class="form-control"
                     placeholder="PIN" v-validate="'required'" :class="{ 'has-error': errors.has('pin') }"/>
              <div class="help text-danger" v-show="errors.has('pin')">
                {{ errors.first("pin") }}
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-common btn-block mt-4 col-md-6" :disabled="is_disabled">
            Add Money
          </button>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import localStorage from '@/services/localStorage'
import { EWTransactionsApi } from '@/services/api'
import { Notification } from 'element-ui'
import TransactionType from '@/services/constants/TransactionType.json'

export default {
  name: 'Dashboard',
  metaInfo: {
    title: 'Dashboard | Dotlines'
  },
  data: () => ({
    is_disabled: false,
    is_loading: false,
    type: 'password',
    params: {
      trx_activity_type: TransactionType.make_payment.id
    }
  }),
  methods: {
    makePayment: function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _this = this
      //console.log('add money')
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.is_loading = true
          EWTransactionsApi.doTransactions(this.params)
            .then((response) => {
              console.log('doTransactions', response)
              if (response.code >= 200 && response.code < 300) {
                this.resetParams()
                Notification.success({ title: 'Transaction Successful', message: 'The amount is successfully transferred to the Receiver', type: 'success' })
              }
            })
            .catch((error) => {
              console.log('doTransactions', error)
              _this.$setErrorsFromResponse(error.response.data)
            })
            .finally(() => {
              this.is_loading = false
            })
        }
      })
    },
    resetParams: function () {
      this.params = {
        trx_activity_type: TransactionType.make_payment.id
      }
    },
    initialize: function () {
      this.type = localStorage.get('security_type').type
    }
  },
  mounted () {
    if (this.isMobile()) {
      window.$(document).find('.push-menu-class').trigger('click')
    }
    const windowReload = localStorage.get('window_reload')
    if (windowReload) {
      localStorage.set('window_reload', false)
      window.location.reload()
    }
    this.initialize()
  }
}
</script>
